import React from "react";
import { ErrorBanner } from "../../../components/Error/ErrorBanner.tsx";
import { convertStringUndefined } from "../../../components/navigation/SearchString.tsx";
import { useRequiredSelectedCompanyId } from "../../../hooks/useCompany";
import {
  type GetIssuesIssueGetQueryParams,
  type IssueCategories,
  type IssueWithAssetRegister,
  useGetIssuesIssueGet,
} from "../../../kubb";
import IssueListFilterForm from "./IssueListFilterForm.tsx";
import IssueSelectComponent from "./IssueSelectComponent.tsx";

interface IssueSelectComponentWrapperProps {
  initialValues: GetIssuesIssueGetQueryParams;
  setValues: (values: IssueWithAssetRegister[]) => void;
  lastUpdateDate: Date;
  issueCategories: IssueCategories[];
}

export default function IssueSelectComponentWrapper(
  props: IssueSelectComponentWrapperProps,
): React.ReactElement {
  const [params, setParams] = React.useState<GetIssuesIssueGetQueryParams>(
    props.initialValues,
  );

  const companyId = useRequiredSelectedCompanyId();
  const query = useGetIssuesIssueGet(
    {
      company_id: companyId,
      ...convertStringUndefined(params),
      include_closed: true,
      categories: props.issueCategories,
    },
    {
      query: {
        refetchInterval: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        refetchOnReconnect: false,
      },
    },
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: we want to trigger when lastUpdateDate changes
  React.useEffect(() => {
    query.refetch();
  }, [props.lastUpdateDate, query.refetch]);
  return (
    <>
      <IssueListFilterForm
        onSubmit={setParams}
        filters={params}
        includeSchemeFilter={true}
        includeCancelledFilter={false}
      />
      {query.error && <ErrorBanner error={query.error} />}
      <div className={"my-1 h-[300px]"}>
        <IssueSelectComponent
          loading={query.isLoading || query.isRefetching}
          items={query.data?.data || []}
          setValues={props.setValues}
        />
      </div>
    </>
  );
}
